import { render, staticRenderFns } from "./ContractorsDocumentsFilteredList.vue?vue&type=template&id=0ff647d6&scoped=true"
import script from "./ContractorsDocumentsFilteredList.vue?vue&type=script&lang=ts"
export * from "./ContractorsDocumentsFilteredList.vue?vue&type=script&lang=ts"
import style0 from "./ContractorsDocumentsFilteredList.vue?vue&type=style&index=0&id=0ff647d6&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ff647d6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0ff647d6')) {
      api.createRecord('0ff647d6', component.options)
    } else {
      api.reload('0ff647d6', component.options)
    }
    module.hot.accept("./ContractorsDocumentsFilteredList.vue?vue&type=template&id=0ff647d6&scoped=true", function () {
      api.rerender('0ff647d6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/documents/ContractorsDocumentsFilteredList.vue"
export default component.exports